<ngb-toast
  *ngFor="let feedback of feedbacksService.feedbacks"
  [class]="feedback.classname"
  [autohide]="true"
  [delay]="feedback.delay || 5000"
  (hidden)="feedbacksService.removeFeedback(feedback)"
>
  {{ feedback.message }}
</ngb-toast>
